"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styled = require("../buttons/close-button/styled");
var _styled2 = require("../base/styled");
var _constant = require("../../constant");
var _styled3 = require("./styled");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var FilePreview = function FilePreview(_ref) {
  var fileName = _ref.fileName,
    url = _ref.url,
    imageHeight = _ref.imageHeight,
    imageWidth = _ref.imageWidth,
    onRemove = _ref.onRemove;
  return /*#__PURE__*/_react.default.createElement(_styled2.Row, null, /*#__PURE__*/_react.default.createElement(_styled3.Container, null, onRemove && /*#__PURE__*/_react.default.createElement(_styled.CloseButton, {
    $bsStyle: {
      position: 'absolute',
      top: 0,
      right: 0,
      width: '35px',
      height: '35px',
      zIndex: 3
    },
    onClick: onRemove
  }), [_constant.filesExtensions.PNG, _constant.filesExtensions.JPEG, _constant.filesExtensions.JPG].includes(fileName.split('.').pop().toLowerCase()) && /*#__PURE__*/_react.default.createElement("img", {
    src: url,
    alt: "".concat(fileName, "-preview"),
    height: imageHeight,
    width: imageWidth
  }), [_constant.filesExtensions.MP4, _constant.filesExtensions.MOV, _constant.filesExtensions.MPEG_4].includes(fileName.split('.').pop().toLowerCase()) && /*#__PURE__*/_react.default.createElement(_styled3.Video, {
    src: "".concat(url, "#t=0.1"),
    controls: true
  }, /*#__PURE__*/_react.default.createElement("track", {
    src: fileName,
    kind: "captions",
    srcLang: "en",
    label: "english_captions"
  }))));
};
FilePreview.propTypes = {
  onRemove: _propTypes.default.func,
  fileName: _propTypes.default.string.isRequired,
  url: _propTypes.default.string.isRequired,
  imageHeight: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  imageWidth: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])
};
FilePreview.defaultProps = {
  onRemove: undefined,
  imageHeight: 300,
  imageWidth: 300
};
var _default = FilePreview;
exports.default = _default;